<template>
  <v-card flat>
   <div style="margin-left: 1%; margin-right: 1%">
     <v-layout row wrap fluid v-if="route === 'Index'">
       <v-flex lg2 md2 sm12>
         <v-container>
           <br>
           <v-dialog
             ref="dialog"
             persistent
             v-model="modal1"
             lazy
             full-width
             width="290px"
             :return-value.sync="booking.check_in"
           >
             <v-text-field
               slot="activator"
               label="Check-in"
               v-model="booking.check_in"
               readonly
             ></v-text-field>
             <v-date-picker
               v-model="booking.check_in"
               :min="start_date"
               scrollable>
               <v-spacer></v-spacer>
               <v-btn :depressed="true" flat color="primary" @click="modal1 = false">Cancel</v-btn>
               <v-btn :depressed="true" flat color="primary" @click="$refs.dialog.save(booking.check_in)">OK</v-btn>
             </v-date-picker>
           </v-dialog>
         </v-container>
       </v-flex>
       <v-flex lg2 md2 sm12>
         <v-container>
           <br>
           <v-dialog
             ref="dialog1"
             persistent
             v-model="modal2"
             lazy
             full-width
             width="290px"
             :return-value.sync="booking.check_out"
           >
             <v-text-field
               slot="activator"
               label="Check-out"
               v-model="booking.check_out"
               readonly
             ></v-text-field>
             <v-date-picker
               v-model="booking.check_out"
               :min="booking.check_in"
               @input="retrievePricingSchedule()"
               scrollable>
               <v-spacer></v-spacer>
               <v-btn :depressed="true" flat color="primary" @click="modal2 = false">Cancel</v-btn>
               <v-btn :depressed="true" flat color="primary" @click="$refs.dialog1.save(booking.check_out)">OK</v-btn>
             </v-date-picker>
           </v-dialog>
         </v-container>
       </v-flex>
       <v-flex lg3 md3 sm12>
         <v-container>
           Conservation Entry Fees
           <guests></guests>
         </v-container>
       </v-flex>
       <v-flex lg3 md3 sm12>
         <v-container>
           Vehicle Entry Fees
           <vehicle/>
         </v-container>
       </v-flex>
       <v-flex lg2 md3 sm12 xs12>
         <v-container>
           <br>
           <v-btn :depressed="true" block color="primary" @click="makeReservation()">{{bookButton}}</v-btn>
         </v-container>
         <v-snackbar
           :multi-line="true"
           :left="true"
           :vertical="true"
           :timeout="6000"
           color="error"
           v-model="snackbar">
           Check-in and check-out dates must be provided
           <v-btn
             flat
             @click="snackbar = false">
             Close
           </v-btn>
         </v-snackbar>
       </v-flex>
     </v-layout>
     <v-layout row wrap fluid v-else>
       <v-flex lg4 md4 sm12 xs12>
         <v-container>
           <small class="text-center">Select Currency</small>
           <v-menu offset-y absolute  :full-width="true">
             <v-btn :depressed="true" slot="activator" block>
               Currency - {{currency}}
             </v-btn>
             <v-list>
               <v-list-tile v-for="(curency, key) in allCurrencies" @click="currencyChange(curency)" :key="key">
                 <v-list-tile-title>{{curency.currency_name}}</v-list-tile-title>
               </v-list-tile>
             </v-list>
           </v-menu>
         </v-container>
       </v-flex>
       <v-flex lg4  md4 sm12 xs12>
         <v-container>
           <small>Conservation Entry Fees</small>
           <guests></guests>
         </v-container>
       </v-flex>
       <v-flex lg4  md4 sm12 xs12>
         <v-container>
           <small>Vehicle Entry Fees</small>
           <vehicle></vehicle>
         </v-container>
       </v-flex>
     
     </v-layout>
   </div>
  </v-card>
</template>

<script>
import Guests from './Guests'
import Vehicle from './Vehicle'
export default {
  name: 'Search',
  components: { Vehicle, Guests },
  data () {
    return {
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      snackbar: false,
      start_date: this.$moment().format('YYYY-MM-DD'),
      adjust: false,
      switch1: true,
      route: this.$route.name,
      booking: {
        days: 0,
        check_in: '',
        check_out: '',
        currency: localStorage.getItem('currency')
      }
    }
  },
  computed: {
    currency: function () {
      return this.$store.state.CurrencyStore.browser_currency
    },
    bookButton: function () {
      var page = this.$route.name.split('.', 1)
      if (page[0] === 'Index') {
        return 'Make Booking'
      } else {
        return 'Adjust Booking'
      }
    },
    disabled_settings: function () {
      var startDate = this.$moment().format('YYYY-MM-DD')
      // var endDate = this.$store.state.BookingStore.local_booking.check_out
      // this.activity.date = this.$moment(startDate).format('YYYY, MM, DD')
      return {
        to: new Date(this.$moment(startDate).format('YYYY, MM, DD'))
        // from: new Date(this.$moment(endDate).add(1, 'd').format('YYYY, MM, DD'))
      }
    }
  },
  created () {
    if (localStorage.getItem('booking') !== null) {
      var booking = JSON.parse(localStorage.getItem('booking'))
      this.booking = booking
      this.date_settings['check-in'] = booking.check_in
      this.date_settings['check-out'] = booking.check_out
    }
    this.$store.dispatch('get_all_currencies')
  },
  methods: {
    storeVehicles: function () {
      localStorage.setItem('vehicle_data', JSON.stringify(this.allVehicles))
    },
    storeConservation: function () {
      localStorage.setItem('conservation_data', JSON.stringify(this.allConservationFees))
    },
    // make reservation
    makeReservation: function () {
      if (this.booking.check_in === '' || this.booking.check_out === '') {
        this.snackbar = true
        // this.$notify({
        //   type: 'warning',
        //   group: 'foo',
        //   title: 'Missing Data',
        //   text: 'You need a check-in and check-out date to proceed',
        //   classes: 'alert-wrapper'
        // })
      } else {
        this.adjustDates(this.booking.check_in, this.booking.check_out)
        this.storeConservation()
        this.storeVehicles()
        this.$router.push({
          name: 'Reservation'
        })
      }
    },
    // Currency
    setCurrency: function (data) {
      this.booking.currency = data
      localStorage.setItem('currency', data)
      this.$store.state.CurrencyStore.browser_currency = data
    },
    // Date Functions
    putStartDate: function () {
      var date = this.booking.check_in
      date = this.$moment(date).format('YYYY-MM-DD')
      this.booking.check_in = date
    },
    putEndDate: function () {
      var date = this.booking.check_out
      date = this.$moment(date).format('YYYY-MM-DD')
      this.booking.check_out = date
      var a = this.$moment(this.$moment(this.booking.check_in).format('YYYY, MM, DD'))
      var b = this.$moment(this.$moment(this.booking.check_out).format('YYYY, MM, DD'))
      this.booking.days = b.diff(a, 'days')
    },
    retrievePricingSchedule: function () {
      let data = {
        check_in_date: this.booking.check_in,
        check_out_date: this.booking.check_out
      }
      this.$store.dispatch('get_conservation_fee_by_check_in_out_date', data)
    }
  }
}
</script>

<style scoped>

</style>
